import { Accordion } from "@wise-emotions/react-accordion";
import { AccordionItemProps } from "../../types";
import React from "react";
import parse from "html-react-parser";

export const convertCfAccordionItemProps = ({
  label,
  children,
}: AccordionItemProps) => {
  return {
    title: parse(label) as string,
    children,
  };
};

const CfAccordionItem = (props: AccordionItemProps) => {
  return (
    <Accordion variant="default" {...convertCfAccordionItemProps(props)} />
  );
};

export default CfAccordionItem;
